export interface IScheduleConstraint {
	UserId: string
	Title: string
	Note: string
	NoteList: string[]
	Severity: EScheduleConstraintSeverity
	Type: EScheduleConstraintType
}

export enum EScheduleConstraintSeverity {
	Warning = 0,
	Error = 1,
	Info = 2
}

export enum EScheduleConstraintType {
	ConflictsWithSchedule = 0,
	ConflictsWithLeave = 1,
	OutsideEmployeePreferredWorkTime = 2,
	EmployeeWillIncurOvertime = 3,
	ConsecutiveShiftRuleViolation = 4,
	ShiftPunchLevelInvalid = 5,
	ConflictsWithWorkPreferences = 6,
	ConflictWithShiftPaytype = 7,
	ConflictWithBreakPaytype = 8,
	ConflictWithHoliday = 9,
	ScheduleNameInvalid = 10,
	ShiftDateNotMatchWithJobDates = 11,
	ShiftPunchLevelInvalidForEmployee = 12,
	ShiftTimeIsOutOfSchedule = 13,
	NoMatchShiftPosition = 14,
	NoMatchWithScheduleHierarchy = 15,
	NoMatchWithScheduleJob = 16,
	NoMatchWithScheduleClient = 17,
	ScheduleDateNotMatchWithJobDates = 18,
	ConflictsWithExcludeWeekends = 19,
	InvalidAssignedEmployee = 20
}